package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.CommodoreSimpleIcons: ImageVector
    get() {
        if (_commodoreSimpleIcons != null) {
            return _commodoreSimpleIcons!!
        }
        _commodoreSimpleIcons = Builder(name = "CommodoreSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(11.20f, 0.80f)
                curveTo(5.02f, 0.80f, 0.0f, 5.81f, 0.0f, 12.0f)
                reflectiveCurveToRelative(5.02f, 11.20f, 11.20f, 11.20f)
                curveToRelative(1.09f, 0.0f, 2.15f, -0.16f, 3.15f, -0.45f)
                verticalLineToRelative(-5.34f)
                arcToRelative(6.27f, 6.27f, 0.0f, true, true, 0.0f, -10.84f)
                verticalLineToRelative(-5.33f)
                curveToRelative(-1.0f, -0.29f, -2.06f, -0.45f, -3.15f, -0.45f)
                close()
                moveTo(14.58f, 7.14f)
                verticalLineToRelative(4.30f)
                horizontalLineToRelative(5.27f)
                lineTo(24.0f, 7.14f)
                close()
                moveTo(14.54f, 12.52f)
                verticalLineToRelative(4.30f)
                horizontalLineToRelative(9.42f)
                lineToRelative(-4.16f, -4.30f)
                close()
            }
        }
        .build()
        return _commodoreSimpleIcons!!
    }

private var _commodoreSimpleIcons: ImageVector? = null
